import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';
import AboutCompany from '../Elements/AboutCompany';
import Specialization3 from '../Elements/Specialization3';
import AllServices2 from '../Elements/AllServices2';
import OurServices from '../Elements/OurServices';
import AllServices from '../Elements/AllServices';
import AllServices3 from '../Elements/AllServices3';
import OurValue3 from '../Elements/OurValue3';
import OurProject2 from '../Elements/OurProject2';
import Faq from '../Elements/Faq';
import { NavLink } from 'react-router-dom';

var bnrimg = require('./../../images/banner/7.jpg');
var bnr1 = require('./../../images/background/bg-6.png');


class Przeglady extends React.Component {
    render() {
        return (
            <>

                <Header />
                <div className="page-content">
                    <Banner  title="Przeglądy i remonty " pagename="Usługi" bgimage={bnrimg}/>
                    <div className="section-full p-t80 bg-white">
                    <div className="container">
                        <div className="section-content ">
                            <div className="m-service-containt text-black">
                                <div className="row">
                                    <div className="col-md-5 col-sm-12">
                                        <div className="service-about-left">
                                            <div className="mt-media">
                                                <img src={require('./../../images/services/s4.webp')} alt=" A scene depicting slightly older, yet still young skatepark designers actively working on a project using CAD software on a computer. "/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-7 col-sm-12">
                                    <div className="service-about-right m-b30">
    <h3 className="m-t0">Trwałość każdej konstrukcji jest ograniczona .</h3>
    <p>Każdy skatepark po pewnym czasie wymaga odświeżenia lub przebudowy.
Oferujemy przeglądy wraz z opinią o stanie obiektu i wyceną napraw oraz kompleksowe remonty</p>
    <div className="call-for-quote-outer">
        <div className="call-quote">
            <span>Chcesz odnowić swój skatepark? Zadzwoń!</span>
            <h4 >PL +48 500 073 261</h4>
                                <h4>ENG/PL +48 602 762 478</h4>
        </div>
        <div className="call-estimate bg-dark">
        <a href={`mailto:biuro@skate-arena.pl?subject=Przegląd lub remont skateparku w [MIEJSCE]&body=${encodeURIComponent("Dzień dobry,\n\nZainteresowała mnie oferta Państwa usług przeglądu lub remontu istniejącego skateparku. Proszę o przesłanie dalszych informacji dotyczących możliwości współpracy oraz szczegółów technicznych. Oto moje dane kontaktowe:\nTelefon: [Twój numer telefonu]\nPozdrawiam,\n\n[Twoje Imię i Nazwisko]")}`} className="site-button">
    lub wyślij do nas email!
</a>
        </div>
    </div>
</div>

</div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
          
                    
                 

                <Footer />
                    
                </div>

                
               

            </>
        );
    };
};

export default Przeglady;